import { render, staticRenderFns } from "./distributionOfCommissions.vue?vue&type=template&id=09d85c14&scoped=true"
import script from "./distributionOfCommissions.vue?vue&type=script&lang=js"
export * from "./distributionOfCommissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d85c14",
  null
  
)

export default component.exports